import { render, staticRenderFns } from "./OrderPending.vue?vue&type=template&id=4e8e23e4"
import script from "./OrderPending.vue?vue&type=script&lang=js"
export * from "./OrderPending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports